import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'

import { CheckIcon, ReportIcon, SafeIcon, CompliantIcon } from '@segment/matcha/components/Icons/Brandbook'
import IconWrapper from '@segment/matcha/components/IconWrapper'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const features = [
  {
    heading: `Data Processing Agreement`,
    description: `Our updated Data Processing Agreement (DPA) reflects the requirements of the CCPA.`,
    IconComponent: CheckIcon,
  },
  {
    heading: `Privacy By Design`,
    description: `Segment takes a holistic approach to security and privacy, and does not sell our customers' user data.`,
    IconComponent: SafeIcon,
  },
  {
    heading: `Updated Privacy Policy`,
    description: `We will update our Privacy Policy to honor both the CCPA and our commitment to privacy.`,
    IconComponent: ReportIcon,
  },
  {
    heading: `Data Protection Officer`,
    description: `Segment has appointed a Data Protection Officer to oversee our ongoing compliance efforts.`,
    IconComponent: CompliantIcon,
  },
]

const FeatureBoxGroup = () => {
  const theme = useTheme()
  const darkAcai = theme.palette.brand.darkAcai[700]

  return (
    <SectionBaseParentWrapper variant="centered">
      <ColumnTrackWrapper>
        <StyledColumnTrack columns={1} overrides={{ md: 2, lg: 4 }}>
          {features.map((feature) => (
            <FeatureBoxBase key={feature.heading} alignment="left" headerPosition="top">
              <FeatureBox.Header>
                <IconWrapper background="white" elevation={1} variant="circle">
                  <feature.IconComponent color={darkAcai} />
                </IconWrapper>
              </FeatureBox.Header>
              <FeatureBox.Body>
                <FeatureBox.Title>{feature.heading}</FeatureBox.Title>
                <FeatureBox.Text>{feature.description}</FeatureBox.Text>
              </FeatureBox.Body>
            </FeatureBoxBase>
          ))}
        </StyledColumnTrack>
      </ColumnTrackWrapper>
    </SectionBaseParentWrapper>
  )
}

const SectionBaseParentWrapper = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
    padding: 32px 0 0 0;

    ${({ theme }) => theme.breakpoints.up(`md`)} {
      padding: 64px 0 0 0;
    }
  }
`

const ColumnTrackWrapper = styled(Section.Contents)`
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    max-width: 1280px;
  }
`

const StyledColumnTrack = styled(ColumnTrack)`
  gap: 32px;
  align-items: center;
`

export default FeatureBoxGroup
